import { Component, ElementRef, HostBinding, OnInit } from '@angular/core';

@Component({
    selector: 'nova-skeleton-rect',
    standalone: true,
    imports: [],
    template: ``,
    styles: `
        :host {
            display: block;
            width: var(--skeleton-rect-width);
            height: var(--skeleton-rect-height);
            background: rgb(239, 241, 246) no-repeat;
        }
    `
})
export class SkeletonRectComponent implements OnInit {
    @HostBinding('class') class = 'skeleton-loader-pulse';

    width: string;
    height: string;
    className: string;

    constructor(private readonly host: ElementRef<HTMLElement>) {}

    ngOnInit(): void {
        const host = this.host.nativeElement;

        if (this.className) {
            host.classList.add(this.className);
        }

        host.style.setProperty('--skeleton-rect-width', this.width ?? '100%');
        host.style.setProperty('--skeleton-rect-height', this.height ?? '20px');
    }
}
